export const GRAY1 = "#F9F9F9"
export const GRAY2 = "#F5F5F5"

export const GRAY3 = "#ECECEC"
export const GRAY4 = "#E4E4E4"
export const GRAY5 = "#DCDCDC"

export const GRAY6 = "#D4D4D4"
export const GRAY7 = "#C9C9C9"
export const GRAY8 = "#B6B6B6"

export const DARK_BLUE = "#1E1F42"
export const NAVY_BLUE = "#32355A"

export const SECONDARY_TEXT = "#606060"
export const PRIMARY_TEXT = "#202020"
